// components
import Saveday from "../../components/countdown";
import Couple from "../../components/couple";
import Gallery from "../../components/gallery";
import Gift from "../../components/gift";
import SimpleSlider from "../../components/hero";
import Navbar from "../../components/Navbar";
import Rsvp from "../../components/rsvp";
import Story from "../../components/story";
import JourneyBookshelf from "../../components/journey-bookshelf";
import Welcome from "../../components/welcome-area";

const Homepage = () => {
  return (
    <div>
      <Navbar />
      <SimpleSlider />
      <Saveday />
      <Couple />
      <Welcome />
      <Story />
      <JourneyBookshelf />
      {/* <Location /> */}
      <Gallery />
      <Rsvp />
      <Gift />
    </div>
  );
};

export default Homepage;
